module.exports = __webpack_public_path__ + "img/art_7_5.d6f10369.png";